import PageLoader from '../loader/page-loader';
import { IndexView } from '../../views';
import usePlatformRequest from '../../hooks/platform/usePlatformRequest';

export default function Platform() {
  const { ready } = usePlatformRequest();

  return <>{ready ? <IndexView /> : <PageLoader />}</>;
}
